export enum ChatMessageTypeEnum {
    // EzeMart
    CustomerToMerchant = 1, // Order chat
    MerchantToCustomer = 2,

    CustomerToSupport = 3, // CustomerSupport chat
    SupportToCustomer = 4,

    MerchantToSupport = 5, // MerchantSupport chat
    SupportToMerchant = 6,

    SystemToCustomer = 7, // Messages from bot (Order chat)
    SystemToMerchant = 8,

    // Xpress
    CustomerToRider = 9, // XpressOrder chat
    RiderToCustomer = 10,
    SystemToDriver = 11
}
